@if (!disabled) {
  <span class="back" (click)="handleBack()" [inlineSVG]="'/icons/icon-arrow.svg'"></span>
}
<div class="progress-bar">
  <div class="progress" #progress></div>
</div>
